import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.mixRecipes;

export default class MixRecipes extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      name: this.string(''),
      type: this.string(''),
      unique_id: this.string(''),
    };
  }
}
